import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import { changePassword, sendCode as _sendCode, bindPhone } from '@/api/user';
import NoticeDialog from '@/views/notice/components/detail.vue';
import { fetchNoticeList } from '@/api/notice';
export default {
  components: {
    Breadcrumb: Breadcrumb,
    NoticeDialog: NoticeDialog
  },
  data: function data() {
    var _this = this;
    var checkConfirmPassword = function checkConfirmPassword(rule, value, callback) {
      if (_this.passwordForm.password !== _this.passwordForm.password_confirmation) {
        callback(new Error('两次密码码输入不一致'));
      }
      callback();
    };
    var checkPassword = function checkPassword(rule, value, callback) {
      var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z]).{6,30}');
      if (!pwdRegex.test(value)) {
        callback(new Error('您的密码复杂度太低（密码中必须包含字母、数字）'));
      }
      callback();
    };
    return {
      sendInterval: null,
      sendText: '发送验证码',
      bindPhoneDialogFormVisible: false,
      dialogFormVisible: false,
      codeStatus: 0,
      SendForm: {
        phone: '',
        sms_code: ''
      },
      rulesSendForm: {
        phone: [{
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        }],
        sms_code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      passwordForm: {
        current_password: '',
        password: '',
        password_confirmation: ''
      },
      rules: {
        current_password: [{
          required: true,
          message: '请填写原密码',
          trigger: 'blur'
        }],
        password_confirmation: [{
          required: true,
          message: '请再次输入新密码',
          trigger: 'blur'
        }, {
          validator: checkConfirmPassword
        }],
        password: [{
          required: true,
          message: '请填写新密码',
          trigger: 'blur'
        }, {
          validator: checkPassword
        }]
      },
      readNoticeVisible: false,
      newNotice: {}
    };
  },
  computed: _objectSpread({}, mapGetters(['sidebar', 'avatar', 'device', 'name', 'corporationName', 'user'])),
  mounted: function mounted() {
    this.getNotices();
    if (this.user && this.user.is_change_pwd === false) {
      this.dialogFormVisible = true;
    } else if (this.user && this.user.phone === '') {
      this.bindPhoneDialogFormVisible = true;
    }
  },
  methods: {
    getNotices: function getNotices() {
      var _this2 = this;
      fetchNoticeList({
        page: 1,
        limit: 4
      }).then(function (res) {
        if (res.code === 200 && res.data.items.length) {
          _this2.newNotice = res.data.items.length && res.data.items[0];
          if (localStorage.getItem('readNotice') !== 'true') {
            _this2.readNoticeVisible = true;
          }
        }
      });
    },
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    sendCode: function sendCode() {
      var _this3 = this;
      if (this.codeStatus !== 0) {
        return;
      }
      if (!this.SendForm.phone) {
        this.$message({
          message: '请输入手机号码',
          type: 'warning'
        });
        return;
      }
      _sendCode(this.SendForm.phone, 'admin_bind_phone').then(function (res) {
        _this3.$message({
          message: '验证码已发送，请注意查收！',
          type: 'success'
        });
        _this3.codeStatus = 60;
        clearInterval(_this3.sendInterval);
        var fun = function fun() {
          _this3.sendText = '倒计时' + _this3.codeStatus + 's';
          _this3.codeStatus--;
          if (_this3.codeStatus <= 0) {
            _this3.codeStatus = 0;
            _this3.sendText = '重新发送';
          }
        };
        fun();
        _this3.sendInterval = setInterval(fun, 1000);
      });
    },
    logout: function logout() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this4.$store.dispatch('user/logout').then(function (res) {
                _this4.$router.push("/login?redirect=".concat(encodeURIComponent(_this4.$route.fullPath)));
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      this.$refs['pwForm'].validate(function (valid) {
        if (valid) {
          changePassword(_this5.passwordForm).then(function () {
            _this5.dialogFormVisible = false;
            _this5.$store.dispatch('user/getInfo');
            _this5.$notify({
              title: 'Success',
              message: '密码修改成功',
              type: 'success',
              duration: 2000
            });
            _this5.resetForm('bind');
          });
        }
      });
    },
    SendHandleSubmit: function SendHandleSubmit() {
      var _this6 = this;
      this.$refs['sendForm'].validate(function (valid) {
        if (valid) {
          bindPhone(_this6.SendForm).then(function () {
            _this6.bindPhoneDialogFormVisible = false;
            _this6.$store.dispatch('user/getInfo');
            _this6.$notify({
              title: 'Success',
              message: '绑定成功',
              type: 'success',
              duration: 2000
            });
            _this6.resetSendForm();
          });
        }
      });
    },
    handlePasswordChange: function handlePasswordChange() {
      this.dialogFormVisible = true;
    },
    resetForm: function resetForm(flag) {
      this.passwordForm.current_password = '';
      this.passwordForm.password = '';
      this.passwordForm.password_confirmation = '';
      this.$refs.pwForm.resetFields();
      if (this.user && this.user.is_change_pwd === false && flag === 'pwd') {
        this.dialogFormVisible = true;
      } else if (this.user && this.user.phone === '' && flag === 'bind') {
        this.bindPhoneDialogFormVisible = true;
      }
    },
    resetSendForm: function resetSendForm() {
      this.passwordForm.phone = '';
      this.passwordForm.sms_code = '';
      this.$refs.sendForm.resetFields();
    }
  }
};